export const theme = {
  breakpoints: [375, 768, 1024, 1440],
  colors: {
    body: '#6d6d6d',
    primary: '#0080a8',
    secondary: '#51c1e4',
    accent: '#747c00',
    wrong: '#ea7220',
    white: '#ffffff',
    lightGrey: '#f9f9f9',
    mediumGrey: '#dddddd',
    darkGrey: '#999999',
  },
  text: {
    textXl: [36, 36, 36, 48],
    textLarge: [28, 32, 32, 32],
    textMedium: [18, 18, 18, 24],
    textBody: 16,
    textSmall: 14,
  },
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 600,
  },
  space: {
    spaceXXl: [40, 40, 40, 80],
    spaceXl: [48, 48, 64, 64],
    spaceLarge: [18, 18, 24, 32],
    spaceNormal: [12, 12, 24, 24],
    spaceSmall: 16,
    spaceXs: 8,
  },
}

export default theme
